var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      attrs: {
        label: "Telefone",
        "label-for": "phone",
        description: "Digite o telefone no formato (XX) XXXXX-XXXX"
      }
    },
    [
      _c("b-form-input", {
        attrs: {
          id: "phone",
          type: "text",
          placeholder: "(XX) XXXXX-XXXX",
          required: "",
          state: _vm.phoneState,
          "aria-describedby": "phone-feedback"
        },
        on: { blur: _vm.validatePhone },
        model: {
          value: _vm.formattedPhone,
          callback: function($$v) {
            _vm.formattedPhone = $$v
          },
          expression: "formattedPhone"
        }
      }),
      _vm._v(" "),
      _c("b-form-invalid-feedback", { attrs: { id: "phone-feedback" } }, [
        _vm._v(
          "\n    Por favor, insira um telefone válido com o código do estado e 9 números.\n  "
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }